import React from 'react';
import PropTypes from 'prop-types';

import {Box, Stack} from 'views/components';
import {TaskEditor, Translate} from 'views/module';

import TaskView from './TaskView';

const TaskList = (props) => {
  const [isEditorOpen, setIsEditorOpen] = React.useState(false);
  const [editingTaskRn, setEditingTaskRn] = React.useState(null);

  const caregiverTasks = props.caregiverTasks;
  const caregiverBackend = props.caregiverBackend;

  const closeEditor = () => {
    setIsEditorOpen(false);
    setEditingTaskRn(null);
  };

  const addTask = () => {
    setEditingTaskRn(null);
    setIsEditorOpen(true);
  };

  const editTask = (task) => {
    setIsEditorOpen(false);
    setEditingTaskRn(task.taskRn);
  };

  const edits = {
    addTask: (taskData) => {
      const complete = () => {
        setIsEditorOpen(false);
      };
      caregiverBackend.tasks.addTask(taskData, complete);
    },
    editTask: (taskRn, taskData) => {
      const complete = () => {
        setEditingTaskRn(null);
      };
      caregiverBackend.tasks.updateTask(taskRn, taskData, complete);
    },
    removeTask: (taskData) => {
      const complete = () => {
        setEditingTaskRn((previousTaskRn) => (previousTaskRn === taskData.taskRn ? null : previousTaskRn));
      };
      caregiverBackend.tasks.removeTask(taskData.taskRn, complete);
    },
  };

  return (
    <Stack>
      {
        caregiverTasks.map((task, index) => (
          editingTaskRn === task.taskRn ?
            <Box key={task.taskRn || index} sx={{mb: 1, px: 2, pt: 1}}>
              <TaskEditor
                isEditing
                task={task}
                onCancel={closeEditor}
                onSubmit={(payload) => edits.editTask(task.taskRn, payload)}
              />
            </Box> :
            <TaskView
              key={task.taskRn || index}
              task={task}
              onClickEditTask={editTask}
              removeTask={edits.removeTask}
            />
        ))
      }
      {
        isEditorOpen ?
          <Box sx={{mt: 1, px: 2}}>
            <TaskEditor
              onCancel={closeEditor}
              onSubmit={edits.addTask}
            />
          </Box> :
          <Box sx={{px: 2, py: 1}}>
            <Box
              component='button'
              onClick={addTask}
              sx={{
                background: 'none',
                border: 'none',
                color: 'primary.main',
                cursor: 'pointer',
                display: 'inline-flex',
                alignItems: 'center',
                gap: '4px',
                fontSize: '14px',
                p: 0,
              }}
            >
              <Box component='span'>+</Box>
              <Translate expression='tasks.Common.NewTask' />
            </Box>
          </Box>
      }
    </Stack>
  );
};

TaskList.propTypes = {
  caregiverData: PropTypes.object,
  caregiverTasks: PropTypes.array.isRequired,
  caregiverBackend: PropTypes.object.isRequired,
};

export default React.memo(TaskList);
